<template>
  <div v-if="isFaq" class="mobile-menu__faq-header">
    <RouterLink to="/">
      <img
        src="/images/logo_blanc.svg"
        width="200"
        height="58"
        class="mobile-menu__logo"
        v-reveal="{ delay: 200, repeat: true }"
      />
    </RouterLink>

    <div class="mobile-menu__lang">
      <button @click="switchLang('fr')">FR</button>
      /
      <button @click="switchLang('en')">EN</button>
      /
      <GoogleTranslate />
    </div>
  </div>

  <div class="mobile-menu" :class="{ '-active': menuOpen }" v-if="!isFaq">
    <div class="mobile-menu__content" v-if="menuOpen">
      <div class="mobile-menu__lang" v-reveal="{ repeat: true }">
        <button @click="switchLang('fr')">FR</button> /
        <button @click="switchLang('en')">EN</button> /
        <GoogleTranslate />
      </div>

      <img
        src="/images/logo_blanc.svg"
        width="200"
        height="58"
        class="mobile-menu__logo"
        v-reveal="{ delay: 200, repeat: true }"
      />

      <div class="mobile-menu__links">
        <template v-for="(item, key) in $beet.options.menus.main">
          <RouterLink
            @click="menuOpen = false"
            v-if="isInternalMenuItem(item)"
            :key="key"
            class="navbar__link"
            :to="item.link"
          >
            {{ item.label }}
          </RouterLink>

          <a
            v-else-if="item.link"
            target="_blank"
            rel="noopener"
            :href="item.link"
            :key="`link-${key}`"
            class="navbar__link"
          >
            {{ item.label }}
          </a>
        </template>
      </div>

      <button
        class="button mobile-menu__reservation"
        @click="openReservations()"
        v-reveal="{ repeat: true, delay: 400 }"
      >
        {{ $t('reservation') }}
      </button>

      <div class="mobile-menu__contact" v-reveal="{ repeat: true, delay: 500 }">
        <a class="link text" :href="`tel:${contact.phone}`">
          {{ $t('call') }}<br />{{ contact.phone }}
        </a>
      </div>
    </div>
  </div>

  <div class="mobile-nav" :class="{ '-reverse': reverse || menuOpen }" v-if="!isFaq">
    <div class="mobile-nav__toggle" :class="{ '-active': menuOpen }" @click="menuOpen = !menuOpen">
      <svg
        class="mobile-nav__logo"
        width="38px"
        height="36px"
        viewBox="0 0 38 36"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-700.000000, -1002.000000)" fill="currentColor">
            <g id="" transform="translate(593.000000, 930.000000)">
              <g id="Icone" transform="translate(107.000000, 72.000000)">
                <polygon
                  id="Fill-1"
                  points="30.9582 12.6038 30.9582 22.8228 31.8932 22.2068 31.8932 11.9868"
                ></polygon>
                <polygon
                  id="Fill-2"
                  points="26.3745 16.9607 25.7265 17.8497 36.4775 17.8497 37.1255 16.9607"
                ></polygon>
                <polygon
                  id="Fill-3"
                  points="24.3999 18.8381 24.3999 29.0571 25.3349 28.4411 25.3349 18.2211"
                ></polygon>
                <polygon
                  id="Fill-4"
                  points="19.8162 23.195 19.1682 24.084 29.9182 24.084 30.5662 23.195"
                ></polygon>
                <polygon
                  id="Fill-5"
                  points="17.8416 25.0724 17.8416 35.2914 18.7766 34.6754 18.7766 24.4564"
                ></polygon>
                <polygon
                  id="Fill-6"
                  points="13.2588 29.4293 12.6108 30.3183 23.3608 30.3183 24.0088 29.4293"
                ></polygon>
                <polygon
                  id="Fill-7"
                  points="19.2834 0.0002 18.3484 0.6162 18.3484 10.8352 19.2834 10.2192"
                ></polygon>
                <polygon
                  id="Fill-8"
                  points="13.7646 4.9736 13.1166 5.8616 23.8666 5.8616 24.5146 4.9736"
                ></polygon>
                <polygon
                  id="Fill-9"
                  points="11.79 6.8501 11.79 17.0691 12.725 16.4541 12.725 6.2341"
                ></polygon>
                <polygon
                  id="Fill-10"
                  points="7.2063 11.2079 6.5583 12.0959 17.3083 12.0959 17.9573 11.2079"
                ></polygon>
                <polygon
                  id="Fill-11"
                  points="5.2317 13.0844 5.2317 23.3034 6.1667 22.6884 6.1667 12.4684"
                ></polygon>
                <polygon
                  id="Fill-12"
                  points="0.648 17.4422 0 18.3302 10.751 18.3302 11.399 17.4422"
                ></polygon>
                <polygon
                  id="Fill-13"
                  points="24.6528 6.6098 24.6528 16.8288 25.5878 16.2128 25.5878 5.9938"
                ></polygon>
                <polygon
                  id="Fill-14"
                  points="20.07 10.9667 19.421 11.8557 30.172 11.8557 30.82 10.9667"
                ></polygon>
                <polygon
                  id="Fill-15"
                  points="18.0954 12.8441 18.0954 23.0631 19.0294 22.4471 19.0294 12.2281"
                ></polygon>
                <polygon
                  id="Fill-16"
                  points="13.5117 17.201 12.8637 18.09 23.6137 18.09 24.2617 17.201"
                ></polygon>
                <polygon
                  id="Fill-17"
                  points="11.5371 19.0784 11.5371 29.2974 12.4721 28.6824 12.4721 18.4624"
                ></polygon>
                <polygon
                  id="Fill-18"
                  points="6.9534 23.4362 6.3054 24.3242 17.0554 24.3242 17.7044 23.4362"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <div class="mobile-nav__toggle-text">{{ menuOpen ? $t('close') : $t('browse') }}</div>
    </div>
  </div>
</template>

<script>
import GoogleTranslate from '../GoogleTranslate.vue'

export default {
  name: 'MobileNav',
  components: { GoogleTranslate },
  data() {
    return {
      menuOpen: false,
      reverse: false,
      currentSectionId: null,
    }
  },
  watch: {
    menuOpen(to) {
      if (to) {
        document.body.classList.add('--no-scroll')
      } else {
        document.body.classList.remove('--no-scroll')
      }
    },
  },
  computed: {
    contact() {
      return this.$beet.options.contact
    },
    isFaq() {
      const path = this.$route.path?.replace(/\/$/, '')

      const hash = this.$route.hash || ''

      return (
        path === '/faq' || path?.endsWith('/faq') || hash === '#faq' || hash.startsWith('#faq-')
      )
    },
  },
  mounted() {
    const observer = new IntersectionObserver(this.handleSection, {
      threshold: 0.15,
    })
    const sections = document.querySelectorAll('section')
    sections.forEach((section) => {
      observer.observe(section)
    })
  },
  methods: {
    isInternalMenuItem(item) {
      return item.flexLayout === 'internal-link-repeatable'
    },

    switchLang(lang) {
      const href = window.location.href
      if (href.includes('translate.goog')) {
        const index = href.indexOf('-com')
        const domain = href.slice(0, index)
        const url = `${domain}.com`
        window.location.replace(`${url}/${lang === 'en' ? 'en' : ''}`)
      } else {
        this.$i18n.locale = lang
      }
    },
    openReservations() {
      window.open(
        'https://www.opentable.ca/booking/restref/availability?lang=en-CA&correlationId=87f0eac8-62c2-485c-b32b-297ac5ce6e74&restRef=1147108&otSource=Other',
        '_blank',
      )
    },
    handleSection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target?.classList[0]) {
            if (
              entry.target.classList[0].includes('header') ||
              entry.target.classList[0].includes('section-gradient') ||
              entry.target.classList[0].includes('section-experiences')
            ) {
              this.reverse = true
            } else {
              this.reverse = false
            }
          } else {
            this.reverse = false
          }
        }
      })
    },
  },
}
</script>
